import { FilterFn } from '@tanstack/react-table';

export const multiDropDownFilter: FilterFn<unknown> = (row, columnId, value) => {
  if (!value?.size) return true;

  const filterValues = Array.from(value.keys());
  const columnValue = row.getValue(columnId);
  return filterValues.includes(columnValue);
};
